import { createSlice } from '@reduxjs/toolkit';
import { createGlobalMenu, fetchGlobalMenu } from './globalMenuThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITAL_STATE = {
  isLoading: false,
  currentGlobalMenu: null,
  status: 'idle',
  error: null
};

const globalMenuSlice = createSlice({
  name: 'GLOBAL_MENU',
  initialState: INITAL_STATE,
  reducers:{},
  extraReducers: (builder) => {
    builder
      // Handling Global Menu API Response
      .addCase(fetchGlobalMenu.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(fetchGlobalMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        const data = action.payload.data;
        if (Array.isArray(data) && data.length > 0) {
          state.currentGlobalMenu = data[0];
        } else {
          state.currentGlobalMenu = null;
        }
      })

      //Handling Add Global API Menu Response
      .addCase(createGlobalMenu.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(createGlobalMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.currentGlobalMenu = [action.payload.data];
      })
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.error = action?.payload?.error;
        }
      );
  }
});

export const {} = globalMenuSlice.actions;
export default globalMenuSlice.reducer;
